import { useParams } from 'react-router-dom';
import { Database } from 'lucide-react';
import { CountryOverview, StoreListView, StoreDetailView } from '../../components/admin/store-browser';

export default function StoreDataBrowser() {
  const { country, storeId } = useParams<{ country?: string; storeId?: string }>();

  // Determine which view to show based on URL params
  const renderView = () => {
    if (storeId && country) {
      // Store detail view: /admin/store-browser/:country/:storeId
      return <StoreDetailView />;
    } else if (country) {
      // Country stores list: /admin/store-browser/:country
      return <StoreListView />;
    } else {
      // Country overview: /admin/store-browser
      return <CountryOverview />;
    }
  };

  return (
    <div className="space-y-6">
      {/* Page Header (only on main overview) */}
      {!country && (
        <div className="flex items-center gap-3">
          <div className="p-2 bg-primary-100 rounded-lg">
            <Database className="text-primary-600" size={24} />
          </div>
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">Store Data Browser</h1>
            <p className="text-sm text-gray-500">
              Explore and monitor data quality across all stores
            </p>
          </div>
        </div>
      )}

      {/* Dynamic View */}
      {renderView()}
    </div>
  );
}
